// eslint-disable-next-line import/no-named-as-default
import Analytics from 'analytics'
import type { AnalyticsPlugin } from 'analytics'

import { addEvents, createSession, endSession } from './service'

const portalAnalyticsPlugin: AnalyticsPlugin = {
  name: 'portalAnalyticsPlugin',
  methods: {
    createSession,
    addEvents,
    endSession
  }
}

export const analytics: any = Analytics({
  app: 'epilot-portal-analytics',
  plugins: [portalAnalyticsPlugin]
})
